<template>
  <div class="wrapper wrapper_wide section_footer">
    <div class="frame inner_links active">
      <div class="col">
        <a href="/" class="btn btn_circle btn_map icon-"><span class="inner_text">アクセス</span></a>
      </div>
      <div class="col">
        <a href="/" class="btn btn_circle btn_arrow_u icon-" @click="translate"><span class="inner_text">TOP</span></a>
      </div>
    </div>
    <div class="footer_logo"><img src="/assets/img/common/logo.png" alt=""></div>
    <div class="frame outer_link">
      <div class="col">
        <a :href="hp" target="_blank" rel="noreferrer"><img src="/assets/img/common/icon_official.svg" alt="">OFFICIAL</a>
      </div>
      <div class="col">
        <a class="btn btn_sns btn_fb" href="/"><img src="/assets/img/common/icon_fb.svg" alt=""></a>
        <a class="btn btn_sns btn_ln" href="/"><img src="/assets/img/common/icon_ln.svg" alt=""></a>
        <a class="btn btn_sns btn_tw" href="/"><img src="/assets/img/common/icon_tw.svg" alt=""></a>
        <a class="btn btn_sns btn_gp" href="/"><img src="/assets/img/common/icon_gp.svg" alt=""></a>
      </div>
    </div>
    <p class="copyright">© {{ clinic_name }}</p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SectionFooter',
  props: {
    msg: String
  },
  data () {
    return {
      clinic_name: siteData.info.clinic_name,
      hp: siteData.info.hp
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ])
  },
  methods: {
    ...mapActions([
      'smoothScroll'
    ]),
    translate () {
      this.smoothScroll()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
